import { SvgIcon } from "@mui/material";

const strokeProps = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export function PoloMalletIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <line x1="4" y1="3" x2="15" y2="16.5" {...strokeProps} />
      <rect x="11" y="16.5" width="10" height="3.5" rx="1.75" {...strokeProps} />
      <circle cx="5.5" cy="18.5" r="2.5" fill="currentColor" />
    </SvgIcon>
  );
}

export function PoloHorseIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g transform="translate(-2 0)">
        <path
          d="M8 21 L8.5 16 C8.5 12.5 9.5 9.5 12 7.2 L12.3 3.5 L14.6 5.8 C17.6 6.8 19.8 9.6 20.3 12.6 C20.5 13.6 19.9 14.4 19 14.5 L17.6 14.6 C16.9 14.6 16.3 14.3 15.9 13.7 L15 12.3 L13.6 14.2 C13.3 14.7 13.4 15.3 13.8 15.7 L16.5 18.4 L16.5 21 Z"
          {...strokeProps}
        />
        <circle cx="15.6" cy="9.2" r="0.9" fill="currentColor" />
      </g>
    </SvgIcon>
  );
}

export function PoloGoalIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M3.5 20 L4.25 6 Q5 4.5 5.75 6 L6.5 20 Z" fill="currentColor" />
      <path d="M17.5 20 L18.25 6 Q19 4.5 19.75 6 L20.5 20 Z" fill="currentColor" />
      <line x1="2" y1="20" x2="22" y2="20" {...strokeProps} />
      <circle cx="12" cy="17" r="2" fill="currentColor" />
    </SvgIcon>
  );
}
